var _slicedToArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _toConsumableArray = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _objectSpread = require("/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/objectSpread2.js").default;

!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/rich-text"] = t() : (e.wp = e.wp || {}, e.wp.richText = t());
}(self, function () {
  return function () {
    var e = {
      8424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      7346: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.applyFormat = function applyFormat(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.start,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.end;
          var i = e.formats,
              s = e.activeFormats,
              c = i.slice();

          if (r === o) {
            var _e = (0, n.find)(c[r], {
              type: t.type
            });

            if (_e) {
              var _n = c[r].indexOf(_e);

              for (; c[r] && c[r][_n] === _e;) {
                c[r] = replace(c[r], _n, t), r--;
              }

              for (o++; c[o] && c[o][_n] === _e;) {
                c[o] = replace(c[o], _n, t), o++;
              }
            }
          } else {
            var _e2 = 1 / 0;

            for (var _n2 = r; _n2 < o; _n2++) {
              if (c[_n2]) {
                c[_n2] = c[_n2].filter(function (e) {
                  var r = e.type;
                  return r !== t.type;
                });
                var _r = c[_n2].length;
                _r < _e2 && (_e2 = _r);
              } else c[_n2] = [], _e2 = 0;
            }

            for (var _n3 = r; _n3 < o; _n3++) {
              c[_n3].splice(_e2, 0, t);
            }
          }

          return (0, a.normaliseFormats)(_objectSpread(_objectSpread({}, e), {}, {
            formats: c,
            activeFormats: [].concat(_toConsumableArray((0, n.reject)(s, {
              type: t.type
            })), [t])
          }));
        };
        var n = r(4793),
            a = r(8585);

        function replace(e, t, r) {
          return (e = e.slice())[t] = r, e;
        }
      },
      5362: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.canIndentListItems = function canIndentListItems(e) {
          var t = (0, n.getLineIndex)(e);
          if (void 0 === t) return !1;
          var r = e.replacements,
              a = (0, n.getLineIndex)(e, t),
              o = r[t] || [],
              i = r[a] || [];
          return o.length <= i.length;
        };
        var n = r(7938);
      },
      6091: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.canOutdentListItems = function canOutdentListItems(e) {
          var t = e.replacements,
              r = e.start,
              a = (0, n.getLineIndex)(e, r);
          return void 0 !== t[a];
        };
        var n = r(7938);
      },
      1848: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.changeListType = function changeListType(e, t) {
          var r = e.text,
              i = e.replacements,
              s = e.start,
              c = e.end,
              l = (0, a.getLineIndex)(e, s),
              u = i[l] || [],
              d = i[(0, a.getLineIndex)(e, c)] || [],
              p = (0, o.getParentLineIndex)(e, l),
              f = i.slice(),
              m = u.length - 1,
              _ = d.length - 1;

          var g;

          for (var _e3 = p + 1 || 0; _e3 < r.length; _e3++) {
            if (r[_e3] === n.LINE_SEPARATOR) {
              if ((f[_e3] || []).length <= m) break;
              f[_e3] && (g = !0, f[_e3] = f[_e3].map(function (e, r) {
                return r < m || r > _ ? e : t;
              }));
            }
          }

          if (!g) return e;
          return _objectSpread(_objectSpread({}, e), {}, {
            replacements: f
          });
        };
        var n = r(3614),
            a = r(7938),
            o = r(1687);
      },
      6322: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function FormatEdit(e) {
          var t = e.formatTypes,
              r = e.onChange,
              i = e.onFocus,
              s = e.value,
              c = e.forwardedRef;
          return t.map(function (e) {
            var t = e.name,
                l = e.edit;
            if (!l) return null;
            var u = (0, a.getActiveFormat)(s, t),
                d = void 0 !== u,
                p = (0, o.getActiveObject)(s),
                f = void 0 !== p && p.type === t;
            return (0, n.createElement)(l, {
              key: t,
              isActive: d,
              activeAttributes: d && u.attributes || {},
              isObjectActive: f,
              activeObjectAttributes: f && p.attributes || {},
              value: s,
              onChange: r,
              onFocus: i,
              contentRef: c
            });
          });
        };
        var n = r(1753),
            a = r(710),
            o = r(1841);
      },
      4244: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function __experimentalRichText() {}, t.useRichText = function useRichText(e) {
          var _e$value = e.value,
              t = _e$value === void 0 ? "" : _e$value,
              r = e.selectionStart,
              y = e.selectionEnd,
              h = e.placeholder,
              b = e.preserveWhiteSpace,
              E = e.onSelectionChange,
              T = e.onChange,
              O = e.__unstableMultilineTag,
              P = e.__unstableDisableFormats,
              x = e.__unstableIsSelected,
              _e$__unstableDependen = e.__unstableDependencies,
              R = _e$__unstableDependen === void 0 ? [] : _e$__unstableDependen,
              C = e.__unstableAfterParse,
              A = e.__unstableBeforeSerialize,
              L = e.__unstableAddInvisibleFormats;

          var S = (0, o.useRegistry)(),
              _ref = (0, n.useReducer)(function () {
            return {};
          }),
              _ref2 = _slicedToArray(_ref, 2),
              F = _ref2[1],
              w = (0, n.useRef)();

          function createRecord() {
            var e = w.current.ownerDocument.defaultView,
                t = e.getSelection(),
                r = t.rangeCount > 0 ? t.getRangeAt(0) : null;
            return (0, i.create)({
              element: w.current,
              range: r,
              multilineTag: O,
              multilineWrapperTags: "li" === O ? ["ul", "ol"] : void 0,
              __unstableIsEditableTree: !0,
              preserveWhiteSpace: b
            });
          }

          function applyRecord(e) {
            var _ref3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                t = _ref3.domOnly;

            (0, s.apply)({
              value: e,
              current: w.current,
              multilineTag: O,
              multilineWrapperTags: "li" === O ? ["ul", "ol"] : void 0,
              prepareEditableTree: L,
              __unstableDomOnly: t,
              placeholder: h
            });
          }

          var j = (0, n.useRef)(t),
              M = (0, n.useRef)();

          function setRecordFromProps() {
            j.current = t, M.current = (0, i.create)({
              html: t,
              multilineTag: O,
              multilineWrapperTags: "li" === O ? ["ul", "ol"] : void 0,
              preserveWhiteSpace: b
            }), P && (M.current.formats = Array(t.length), M.current.replacements = Array(t.length)), C && (M.current.formats = C(M.current)), M.current.start = r, M.current.end = y;
          }

          var N = (0, n.useRef)(!1);
          if (M.current) r === M.current.start && y === M.current.end || (N.current = x, M.current = _objectSpread(_objectSpread({}, M.current), {}, {
            start: r,
            end: y
          }));else {
            var I, k, D;
            setRecordFromProps();
            "core/text-color" === (null === (I = M.current) || void 0 === I || null === (k = I.formats[0]) || void 0 === k || null === (D = k[0]) || void 0 === D ? void 0 : D.type) && function handleChangesUponInit(e) {
              M.current = e, j.current = (0, c.toHTMLString)({
                value: A ? _objectSpread(_objectSpread({}, e), {}, {
                  formats: A(e)
                }) : e,
                multilineTag: O,
                preserveWhiteSpace: b
              });
              var t = e.formats,
                  r = e.text;
              S.batch(function () {
                T(j.current, {
                  __unstableFormats: t,
                  __unstableText: r
                });
              }), F();
            }(M.current);
          }

          function handleChange(e) {
            M.current = e, applyRecord(e), j.current = P ? e.text : (0, c.toHTMLString)({
              value: A ? _objectSpread(_objectSpread({}, e), {}, {
                formats: A(e)
              }) : e,
              multilineTag: O,
              preserveWhiteSpace: b
            });
            var t = e.start,
                r = e.end,
                n = e.formats,
                a = e.text;
            S.batch(function () {
              E(t, r), T(j.current, {
                __unstableFormats: n,
                __unstableText: a
              });
            }), F();
          }

          function applyFromProps() {
            setRecordFromProps(), applyRecord(M.current);
          }

          var q = (0, n.useRef)(!1);
          (0, n.useLayoutEffect)(function () {
            q.current && t !== j.current && applyFromProps();
          }, [t]), (0, n.useLayoutEffect)(function () {
            N.current && (applyFromProps(), N.current = !1);
          }, [N.current]);
          var W = (0, a.useMergeRefs)([w, (0, l.useDefaultStyle)(), (0, u.useBoundaryStyle)({
            record: M
          }), (0, d.useCopyHandler)({
            record: M,
            multilineTag: O,
            preserveWhiteSpace: b
          }), (0, f.useSelectObject)(), (0, p.useFormatBoundaries)({
            record: M,
            applyRecord: applyRecord
          }), (0, g.useDelete)({
            createRecord: createRecord,
            handleChange: handleChange,
            multilineTag: O
          }), (0, m.useIndentListItemOnSpace)({
            multilineTag: O,
            createRecord: createRecord,
            handleChange: handleChange
          }), (0, _.useInputAndSelection)({
            record: M,
            applyRecord: applyRecord,
            createRecord: createRecord,
            handleChange: handleChange,
            isSelected: x,
            onSelectionChange: E
          }), (0, v.useSpace)(), (0, a.useRefEffect)(function () {
            applyFromProps(), q.current = !0;
          }, [h].concat(_toConsumableArray(R)))]);
          return {
            value: M.current,
            onChange: handleChange,
            ref: W
          };
        };

        var n = r(1753),
            a = r(3200),
            o = r(8467),
            i = r(9314),
            s = r(2502),
            c = r(6750),
            l = r(4884),
            u = r(9992),
            d = r(3826),
            p = r(8268),
            f = r(7247),
            m = r(1616),
            _ = r(6851),
            g = r(941),
            v = r(2219);
      },
      4731: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useAnchorRef = function useAnchorRef(e) {
          var t = e.ref,
              r = e.value,
              _e$settings = e.settings,
              o = _e$settings === void 0 ? {} : _e$settings;
          var i = o.tagName,
              s = o.className,
              c = o.name,
              l = c ? (0, a.getActiveFormat)(r, c) : void 0;
          return (0, n.useMemo)(function () {
            if (!t.current) return;
            var e = t.current.ownerDocument.defaultView,
                r = e.getSelection();
            if (!r.rangeCount) return;
            var n = r.getRangeAt(0);
            if (!l) return n;
            var a = n.startContainer;

            for (a = a.nextElementSibling || a; a.nodeType !== a.ELEMENT_NODE;) {
              a = a.parentNode;
            }

            return a.closest(i + (s ? "." + s : ""));
          }, [l, r.start, r.end, i, s]);
        };
        var n = r(1753),
            a = r(710);
      },
      9992: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useBoundaryStyle = function useBoundaryStyle(e) {
          var t = e.record;
          var r = (0, n.useRef)(),
              _t$current$activeForm = t.current.activeFormats,
              a = _t$current$activeForm === void 0 ? [] : _t$current$activeForm;
          return (0, n.useEffect)(function () {
            if (!a || !a.length) return;
            var e = "*[data-rich-text-format-boundary]",
                t = r.current.querySelector(e);
            if (!t) return;
            var n = t.ownerDocument,
                o = n.defaultView,
                i = "".concat(".rich-text:focus ".concat(e), " {", "background-color: ".concat(o.getComputedStyle(t).color.replace(")", ", 0.2)").replace("rgb", "rgba")), "}"),
                s = "rich-text-boundary-style";
            var c = n.getElementById(s);
            c || (c = n.createElement("style"), c.id = s, n.head.appendChild(c)), c.innerHTML !== i && (c.innerHTML = i);
          }, [a]), r;
        };
        var n = r(1753);
      },
      3826: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useCopyHandler = function useCopyHandler(e) {
          var t = (0, n.useRef)(e);
          return t.current = e, (0, a.useRefEffect)(function (e) {
            function onCopy(r) {
              var _t$current = t.current,
                  n = _t$current.record,
                  a = _t$current.multilineTag,
                  l = _t$current.preserveWhiteSpace;
              if ((0, i.isCollapsed)(n.current) || !e.contains(e.ownerDocument.activeElement)) return;
              var u = (0, s.slice)(n.current),
                  d = (0, c.getTextContent)(u),
                  p = (0, o.toHTMLString)({
                value: u,
                multilineTag: a,
                preserveWhiteSpace: l
              });
              r.clipboardData.setData("text/plain", d), r.clipboardData.setData("text/html", p), r.clipboardData.setData("rich-text", "true"), r.clipboardData.setData("rich-text-multi-line-tag", a || ""), r.preventDefault();
            }

            return e.addEventListener("copy", onCopy), function () {
              e.removeEventListener("copy", onCopy);
            };
          }, []);
        };
        var n = r(1753),
            a = r(3200),
            o = r(6750),
            i = r(9789),
            s = r(8091),
            c = r(6237);
      },
      4884: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useDefaultStyle = function useDefaultStyle() {
          return (0, n.useCallback)(function (e) {
            e && (e.style.whiteSpace = "pre-wrap", e.style.minWidth = "1px");
          }, []);
        };
        var n = r(1753);
      },
      941: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useDelete = function useDelete(e) {
          var t = (0, n.useRef)(e);
          return t.current = e, (0, a.useRefEffect)(function (e) {
            function onKeyDown(e) {
              var r = e.keyCode,
                  _t$current2 = t.current,
                  n = _t$current2.createRecord,
                  a = _t$current2.handleChange,
                  l = _t$current2.multilineTag;
              if (e.defaultPrevented) return;
              if (r !== o.DELETE && r !== o.BACKSPACE) return;
              var u = n(),
                  d = u.start,
                  p = u.end,
                  f = u.text,
                  m = r === o.BACKSPACE;
              if (0 === d && 0 !== p && p === f.length) return a((0, i.remove)(u)), void e.preventDefault();

              if (l) {
                var _t;

                _t = m && 0 === u.start && 0 === u.end && (0, c.isEmptyLine)(u) ? (0, s.removeLineSeparator)(u, !m) : (0, s.removeLineSeparator)(u, m), _t && (a(_t), e.preventDefault());
              }
            }

            return e.addEventListener("keydown", onKeyDown), function () {
              e.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };
        var n = r(1753),
            a = r(3200),
            o = r(9880),
            i = r(212),
            s = r(346),
            c = r(9408);
      },
      8268: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useFormatBoundaries = function useFormatBoundaries(e) {
          var _ref4 = (0, n.useReducer)(function () {
            return {};
          }),
              _ref5 = _slicedToArray(_ref4, 2),
              t = _ref5[1],
              r = (0, n.useRef)(e);

          return r.current = e, (0, a.useRefEffect)(function (e) {
            function onKeyDown(n) {
              var a = n.keyCode,
                  c = n.shiftKey,
                  l = n.altKey,
                  u = n.metaKey,
                  d = n.ctrlKey;
              if (c || l || u || d || a !== o.LEFT && a !== o.RIGHT) return;

              var _r$current = r.current,
                  p = _r$current.record,
                  f = _r$current.applyRecord,
                  _p$current = p.current,
                  m = _p$current.text,
                  _ = _p$current.formats,
                  g = _p$current.start,
                  v = _p$current.end,
                  _p$current$activeForm = _p$current.activeFormats,
                  y = _p$current$activeForm === void 0 ? [] : _p$current$activeForm,
                  h = (0, i.isCollapsed)(p.current),
                  b = e.ownerDocument,
                  E = b.defaultView,
                  _E$getComputedStyle = E.getComputedStyle(e),
                  T = _E$getComputedStyle.direction,
                  O = "rtl" === T ? o.RIGHT : o.LEFT,
                  P = n.keyCode === O;

              if (h && 0 === y.length) {
                if (0 === g && P) return;
                if (v === m.length && !P) return;
              }

              if (!h) return;
              var x = _[g - 1] || s,
                  R = _[g] || s,
                  C = P ? x : R,
                  A = y.every(function (e, t) {
                return e === C[t];
              });
              var L = y.length;
              if (A ? L < C.length && L++ : L--, L === y.length) return void (p.current._newActiveFormats = C);
              n.preventDefault();

              var S = (A ? C : P ? R : x).slice(0, L),
                  F = _objectSpread(_objectSpread({}, p.current), {}, {
                activeFormats: S
              });

              p.current = F, f(F), t();
            }

            return e.addEventListener("keydown", onKeyDown), function () {
              e.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };
        var n = r(1753),
            a = r(3200),
            o = r(9880),
            i = r(9789);
        var s = [];
      },
      1616: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useIndentListItemOnSpace = function useIndentListItemOnSpace(e) {
          var t = (0, n.useRef)(e);
          return t.current = e, (0, a.useRefEffect)(function (e) {
            function onKeyDown(r) {
              var n = r.keyCode,
                  a = r.shiftKey,
                  l = r.altKey,
                  u = r.metaKey,
                  d = r.ctrlKey,
                  _t$current3 = t.current,
                  p = _t$current3.multilineTag,
                  f = _t$current3.createRecord,
                  m = _t$current3.handleChange;
              if (a || l || u || d || n !== o.SPACE || "li" !== p) return;

              var _ = f();

              if (!(0, i.isCollapsed)(_)) return;
              var g = _.text,
                  v = _.start,
                  y = g[v - 1];
              y && y !== s.LINE_SEPARATOR || (m((0, c.indentListItems)(_, {
                type: e.tagName.toLowerCase()
              })), r.preventDefault());
            }

            return e.addEventListener("keydown", onKeyDown), function () {
              e.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };
        var n = r(1753),
            a = r(3200),
            o = r(9880),
            i = r(9789),
            s = r(3614),
            c = r(7959);
      },
      6851: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useInputAndSelection = function useInputAndSelection(e) {
          var t = (0, n.useRef)(e);
          return t.current = e, (0, a.useRefEffect)(function (e) {
            var r = e.ownerDocument,
                n = r.defaultView;
            var a,
                l = !1;

            function onInput(e) {
              if (l) return;
              var r;
              e && (r = e.inputType);
              var _t$current4 = t.current,
                  n = _t$current4.record,
                  a = _t$current4.applyRecord,
                  o = _t$current4.createRecord,
                  c = _t$current4.handleChange;
              if (r && (0 === r.indexOf("format") || s.has(r))) return void a(n.current);
              var u = o(),
                  _n$current = n.current,
                  d = _n$current.start,
                  _n$current$activeForm = _n$current.activeFormats,
                  p = _n$current$activeForm === void 0 ? [] : _n$current$activeForm;
              c((0, i.updateFormats)({
                value: u,
                start: d,
                end: u.start,
                formats: p
              }));
            }

            function handleSelectionChange(a) {
              if (r.activeElement !== e) return;
              var _t$current5 = t.current,
                  i = _t$current5.record,
                  s = _t$current5.applyRecord,
                  u = _t$current5.createRecord,
                  d = _t$current5.isSelected,
                  p = _t$current5.onSelectionChange;
              if ("selectionchange" !== a.type && !d) return;
              if ("true" !== e.contentEditable) return;
              if (l) return;

              var _u = u(),
                  f = _u.start,
                  m = _u.end,
                  _ = _u.text,
                  g = i.current;

              if (_ !== g.text) return void onInput();
              if (f === g.start && m === g.end) return void (0 === g.text.length && 0 === f && function fixPlaceholderSelection(e) {
                var t = e.getSelection(),
                    r = t.anchorNode,
                    n = t.anchorOffset;
                if (r.nodeType !== r.ELEMENT_NODE) return;
                var a = r.childNodes[n];
                if (!a || a.nodeType !== a.ELEMENT_NODE || !a.getAttribute("data-rich-text-placeholder")) return;
                t.collapseToStart();
              }(n));

              var v = _objectSpread(_objectSpread({}, g), {}, {
                start: f,
                end: m,
                activeFormats: g._newActiveFormats,
                _newActiveFormats: void 0
              }),
                  y = (0, o.getActiveFormats)(v, c);

              v.activeFormats = y, i.current = v, s(v, {
                domOnly: !0
              }), p(f, m);
            }

            function onCompositionStart() {
              l = !0, r.removeEventListener("selectionchange", handleSelectionChange);
            }

            function onCompositionEnd() {
              l = !1, onInput({
                inputType: "insertText"
              }), r.addEventListener("selectionchange", handleSelectionChange);
            }

            function onFocus() {
              var _t$current6 = t.current,
                  e = _t$current6.record,
                  o = _t$current6.isSelected,
                  i = _t$current6.onSelectionChange,
                  s = _t$current6.applyRecord;
              if (o) s(e.current), i(e.current.start, e.current.end);else {
                var _t2 = void 0;

                e.current = _objectSpread(_objectSpread({}, e.current), {}, {
                  start: _t2,
                  end: _t2,
                  activeFormats: c
                }), i(_t2, _t2);
              }
              a = n.requestAnimationFrame(handleSelectionChange), r.addEventListener("selectionchange", handleSelectionChange);
            }

            function onBlur() {
              r.removeEventListener("selectionchange", handleSelectionChange);
            }

            return e.addEventListener("input", onInput), e.addEventListener("compositionstart", onCompositionStart), e.addEventListener("compositionend", onCompositionEnd), e.addEventListener("focus", onFocus), e.addEventListener("blur", onBlur), e.addEventListener("keyup", handleSelectionChange), e.addEventListener("mouseup", handleSelectionChange), e.addEventListener("touchend", handleSelectionChange), function () {
              e.removeEventListener("input", onInput), e.removeEventListener("compositionstart", onCompositionStart), e.removeEventListener("compositionend", onCompositionEnd), e.removeEventListener("focus", onFocus), e.removeEventListener("blur", onBlur), e.removeEventListener("keyup", handleSelectionChange), e.removeEventListener("mouseup", handleSelectionChange), e.removeEventListener("touchend", handleSelectionChange), r.removeEventListener("selectionchange", handleSelectionChange), n.cancelAnimationFrame(a);
            };
          }, []);
        };
        var n = r(1753),
            a = r(3200),
            o = r(7733),
            i = r(9672);
        var s = new Set(["insertParagraph", "insertOrderedList", "insertUnorderedList", "insertHorizontalRule", "insertLink"]),
            c = [];
      },
      7247: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useSelectObject = function useSelectObject() {
          return (0, n.useRefEffect)(function (e) {
            function onClick(t) {
              var r = t.target;
              if (r === e || r.textContent) return;
              var n = r.ownerDocument,
                  a = n.defaultView,
                  o = n.createRange(),
                  i = a.getSelection();
              o.selectNode(r), i.removeAllRanges(), i.addRange(o);
            }

            return e.addEventListener("click", onClick), function () {
              e.removeEventListener("click", onClick);
            };
          }, []);
        };
        var n = r(3200);
      },
      2219: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useSpace = function useSpace() {
          return (0, n.useRefEffect)(function (e) {
            function onKeyDown(e) {
              if (e.defaultPrevented) return;
              var t = e.keyCode,
                  r = e.altKey,
                  n = e.metaKey,
                  o = e.ctrlKey,
                  i = e.key;
              t !== a.SPACE || r || n || o || " " === i && (e.target.ownerDocument.execCommand("insertText", !1, " "), e.preventDefault());
            }

            return e.addEventListener("keydown", onKeyDown), function () {
              e.removeEventListener("keydown", onKeyDown);
            };
          }, []);
        };
        var n = r(3200),
            a = r(9880);
      },
      9292: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.concat = function concat() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          return (0, n.normaliseFormats)(t.reduce(mergePair, (0, a.create)()));
        }, t.mergePair = mergePair;
        var n = r(8585),
            a = r(9314);

        function mergePair(e, t) {
          return e.formats = e.formats.concat(t.formats), e.replacements = e.replacements.concat(t.replacements), e.text += t.text, e;
        }
      },
      5136: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createElement = function createElement(e, t) {
          var r = e.implementation;
          createElement.body || (createElement.body = r.createHTMLDocument("").body);
          return createElement.body.innerHTML = t, createElement.body;
        };
      },
      9314: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.create = create, t.removeReservedCharacters = removeReservedCharacters;
        var n = r(8467),
            a = r(3419),
            o = r(5136),
            i = r(9292),
            s = r(3614);

        function toFormat(e) {
          var t,
              r = e.type,
              o = e.attributes;
          if (o && o.class && (t = (0, n.select)(a.store).getFormatTypeForClassName(o.class), t && (o.class = " ".concat(o.class, " ").replace(" ".concat(t.className, " "), " ").trim(), o.class || delete o.class)), t || (t = (0, n.select)(a.store).getFormatTypeForBareElement(r)), !t) return o ? {
            type: r,
            attributes: o
          } : {
            type: r
          };
          if (t.__experimentalCreatePrepareEditableTree && !t.__experimentalCreateOnChangeEditableValue) return null;
          if (!o) return {
            type: t.name
          };

          var i = {},
              s = {},
              c = _objectSpread({}, o);

          for (var _e4 in t.attributes) {
            var _r2 = t.attributes[_e4];
            i[_e4] = c[_r2], t.__unstableFilterAttributeValue && (i[_e4] = t.__unstableFilterAttributeValue(_e4, i[_e4])), delete c[_r2], void 0 === i[_e4] && delete i[_e4];
          }

          for (var _e5 in c) {
            s[_e5] = o[_e5];
          }

          return {
            type: t.name,
            attributes: i,
            unregisteredAttributes: s
          };
        }

        function create() {
          var _ref6 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = _ref6.element,
              t = _ref6.text,
              r = _ref6.html,
              n = _ref6.range,
              a = _ref6.multilineTag,
              i = _ref6.multilineWrapperTags,
              s = _ref6.__unstableIsEditableTree,
              c = _ref6.preserveWhiteSpace;

          return "string" == typeof t && t.length > 0 ? {
            formats: Array(t.length),
            replacements: Array(t.length),
            text: t
          } : ("string" == typeof r && r.length > 0 && (e = (0, o.createElement)(document, r)), "object" != typeof e ? {
            formats: [],
            replacements: [],
            text: ""
          } : a ? createFromMultilineElement({
            element: e,
            range: n,
            multilineTag: a,
            multilineWrapperTags: i,
            isEditableTree: s,
            preserveWhiteSpace: c
          }) : createFromElement({
            element: e,
            range: n,
            isEditableTree: s,
            preserveWhiteSpace: c
          }));
        }

        function accumulateSelection(e, t, r, n) {
          if (!r) return;
          var a = t.parentNode,
              o = r.startContainer,
              i = r.startOffset,
              s = r.endContainer,
              c = r.endOffset,
              l = e.text.length;
          void 0 !== n.start ? e.start = l + n.start : t === o && t.nodeType === t.TEXT_NODE ? e.start = l + i : a === o && t === o.childNodes[i] ? e.start = l : a === o && t === o.childNodes[i - 1] ? e.start = l + n.text.length : t === o && (e.start = l), void 0 !== n.end ? e.end = l + n.end : t === s && t.nodeType === t.TEXT_NODE ? e.end = l + c : a === s && t === s.childNodes[c - 1] ? e.end = l + n.text.length : a === s && t === s.childNodes[c] ? e.end = l : t === s && (e.end = l + c);
        }

        function filterRange(e, t, r) {
          if (!t) return;
          var n = t.startContainer,
              a = t.endContainer;
          var o = t.startOffset,
              i = t.endOffset;
          return e === n && (o = r(e.nodeValue.slice(0, o)).length), e === a && (i = r(e.nodeValue.slice(0, i)).length), {
            startContainer: n,
            startOffset: o,
            endContainer: a,
            endOffset: i
          };
        }

        function collapseWhiteSpace(e) {
          return e.replace(/[\n\r\t]+/g, " ");
        }

        function removeReservedCharacters(e) {
          return e.replace(new RegExp("[".concat(s.ZWNBSP).concat(s.OBJECT_REPLACEMENT_CHARACTER, "]"), "gu"), "");
        }

        function createFromElement(e) {
          var t = e.element,
              r = e.range,
              n = e.multilineTag,
              a = e.multilineWrapperTags,
              _e$currentWrapperTags = e.currentWrapperTags,
              o = _e$currentWrapperTags === void 0 ? [] : _e$currentWrapperTags,
              c = e.isEditableTree,
              l = e.preserveWhiteSpace;
          var u = {
            formats: [],
            replacements: [],
            text: ""
          };
          if (!t) return u;
          if (!t.hasChildNodes()) return accumulateSelection(u, t, r, {
            formats: [],
            replacements: [],
            text: ""
          }), u;
          var d = t.childNodes.length;

          var _loop = function _loop(_e6) {
            var d = t.childNodes[_e6],
                p = d.nodeName.toLowerCase();

            if (d.nodeType === d.TEXT_NODE) {
              var _e7 = removeReservedCharacters;
              l || (_e7 = function _e7(e) {
                return removeReservedCharacters(collapseWhiteSpace(e));
              });

              var _t3 = _e7(d.nodeValue);

              r = filterRange(d, r, _e7), accumulateSelection(u, d, r, {
                text: _t3
              }), u.formats.length += _t3.length, u.replacements.length += _t3.length, u.text += _t3;
              return "continue";
            }

            if (d.nodeType !== d.ELEMENT_NODE) return "continue";

            if (c && (d.getAttribute("data-rich-text-placeholder") || "br" === p && !d.getAttribute("data-rich-text-line-break"))) {
              accumulateSelection(u, d, r, {
                formats: [],
                replacements: [],
                text: ""
              });
              return "continue";
            }

            if ("script" === p) {
              var _e8 = {
                formats: [,],
                replacements: [{
                  type: p,
                  attributes: {
                    "data-rich-text-script": d.getAttribute("data-rich-text-script") || encodeURIComponent(d.innerHTML)
                  }
                }],
                text: s.OBJECT_REPLACEMENT_CHARACTER
              };
              accumulateSelection(u, d, r, _e8), (0, i.mergePair)(u, _e8);
              return "continue";
            }

            if ("br" === p) {
              accumulateSelection(u, d, r, {
                formats: [],
                replacements: [],
                text: ""
              }), (0, i.mergePair)(u, create({
                text: "\n"
              }));
              return "continue";
            }

            var f = toFormat({
              type: p,
              attributes: getAttributes({
                element: d
              })
            });

            if (a && -1 !== a.indexOf(p)) {
              var _e9 = createFromMultilineElement({
                element: d,
                range: r,
                multilineTag: n,
                multilineWrapperTags: a,
                currentWrapperTags: [].concat(_toConsumableArray(o), [f]),
                isEditableTree: c,
                preserveWhiteSpace: l
              });

              accumulateSelection(u, d, r, _e9), (0, i.mergePair)(u, _e9);
              return "continue";
            }

            var m = createFromElement({
              element: d,
              range: r,
              multilineTag: n,
              multilineWrapperTags: a,
              isEditableTree: c,
              preserveWhiteSpace: l
            });
            if (accumulateSelection(u, d, r, m), f) {
              if (0 === m.text.length) f.attributes && (0, i.mergePair)(u, {
                formats: [,],
                replacements: [f],
                text: s.OBJECT_REPLACEMENT_CHARACTER
              });else {
                var mergeFormats = function mergeFormats(e) {
                  if (mergeFormats.formats === e) return mergeFormats.newFormats;
                  var t = e ? [f].concat(_toConsumableArray(e)) : [f];
                  return mergeFormats.formats = e, mergeFormats.newFormats = t, t;
                };

                mergeFormats.newFormats = [f], (0, i.mergePair)(u, _objectSpread(_objectSpread({}, m), {}, {
                  formats: Array.from(m.formats, mergeFormats)
                }));
              }
            } else (0, i.mergePair)(u, m);
          };

          for (var _e6 = 0; _e6 < d; _e6++) {
            var _ret = _loop(_e6);

            if (_ret === "continue") continue;
          }

          return u;
        }

        function createFromMultilineElement(e) {
          var t = e.element,
              r = e.range,
              n = e.multilineTag,
              a = e.multilineWrapperTags,
              _e$currentWrapperTags2 = e.currentWrapperTags,
              o = _e$currentWrapperTags2 === void 0 ? [] : _e$currentWrapperTags2,
              c = e.isEditableTree,
              l = e.preserveWhiteSpace;
          var u = {
            formats: [],
            replacements: [],
            text: ""
          };
          if (!t || !t.hasChildNodes()) return u;
          var d = t.children.length;

          for (var _e10 = 0; _e10 < d; _e10++) {
            var _d = t.children[_e10];
            if (_d.nodeName.toLowerCase() !== n) continue;
            var p = createFromElement({
              element: _d,
              range: r,
              multilineTag: n,
              multilineWrapperTags: a,
              currentWrapperTags: o,
              isEditableTree: c,
              preserveWhiteSpace: l
            });
            (0 !== _e10 || o.length > 0) && (0, i.mergePair)(u, {
              formats: [,],
              replacements: o.length > 0 ? [o] : [,],
              text: s.LINE_SEPARATOR
            }), accumulateSelection(u, _d, r, p), (0, i.mergePair)(u, p);
          }

          return u;
        }

        function getAttributes(e) {
          var t = e.element;
          if (!t.hasAttributes()) return;
          var r = t.attributes.length;
          var n;

          for (var _e11 = 0; _e11 < r; _e11++) {
            var _t$attributes$_e = t.attributes[_e11],
                _r3 = _t$attributes$_e.name,
                _a = _t$attributes$_e.value;
            if (0 === _r3.indexOf("data-rich-text-")) continue;
            n = n || {}, n[/^on/i.test(_r3) ? "data-disable-rich-text-" + _r3 : _r3] = _a;
          }

          return n;
        }
      },
      710: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getActiveFormat = function getActiveFormat(e, t) {
          return (0, n.find)((0, a.getActiveFormats)(e), {
            type: t
          });
        };
        var n = r(4793),
            a = r(7733);
      },
      7733: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getActiveFormats = function getActiveFormats(e) {
          var t = e.formats,
              r = e.start,
              n = e.end,
              a = e.activeFormats,
              o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          if (void 0 === r) return o;

          if (r === n) {
            if (a) return a;

            var _e12 = t[r - 1] || o,
                _n4 = t[r] || o;

            return _e12.length < _n4.length ? _e12 : _n4;
          }

          return t[r] || o;
        };
      },
      1841: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getActiveObject = function getActiveObject(e) {
          var t = e.start,
              r = e.end,
              a = e.replacements,
              o = e.text;
          if (t + 1 !== r || o[t] !== n.OBJECT_REPLACEMENT_CHARACTER) return;
          return a[t];
        };
        var n = r(3614);
      },
      6996: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFormatType = function getFormatType(e) {
          return (0, n.select)(a.store).getFormatType(e);
        };
        var n = r(8467),
            a = r(3419);
      },
      4768: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getLastChildIndex = function getLastChildIndex(e, t) {
          var r = e.text,
              a = e.replacements;
          var o = a[t] || [];
          var i = t;

          for (var _e13 = t || 0; _e13 < r.length; _e13++) {
            if (r[_e13] !== n.LINE_SEPARATOR) continue;
            if (!((a[_e13] || []).length >= o.length)) return i;
            i = _e13;
          }

          return i;
        };
        var n = r(3614);
      },
      7938: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getLineIndex = function getLineIndex(e) {
          var t = e.start,
              r = e.text,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t,
              o = a;

          for (; o--;) {
            if (r[o] === n.LINE_SEPARATOR) return o;
          }
        };
        var n = r(3614);
      },
      1687: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getParentLineIndex = function getParentLineIndex(e, t) {
          var r = e.text,
              a = e.replacements;
          var o = a[t] || [];
          var i = t;

          for (; i-- >= 0;) {
            if (r[i] !== n.LINE_SEPARATOR) continue;
            if ((a[i] || []).length === o.length - 1) return i;
          }
        };
        var n = r(3614);
      },
      6237: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getTextContent = function getTextContent(e) {
          var t = e.text;
          return t.replace(new RegExp(n.OBJECT_REPLACEMENT_CHARACTER, "g"), "").replace(new RegExp(n.LINE_SEPARATOR, "g"), "\n");
        };
        var n = r(3614);
      },
      7959: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.indentListItems = function indentListItems(e, t) {
          if (!(0, o.canIndentListItems)(e)) return e;

          var r = (0, a.getLineIndex)(e),
              i = (0, a.getLineIndex)(e, r),
              s = e.text,
              c = e.replacements,
              l = e.end,
              u = c.slice(),
              d = function getTargetLevelLineIndex(e, t) {
            var r = e.text,
                a = e.replacements;
            var o = a[t] || [];
            var i = t;

            for (; i-- >= 0;) {
              if (r[i] !== n.LINE_SEPARATOR) continue;

              var _e14 = a[i] || [];

              if (_e14.length === o.length + 1) return i;
              if (_e14.length <= o.length) return;
            }
          }(e, r);

          for (var _e15 = r; _e15 < l; _e15++) {
            if (s[_e15] === n.LINE_SEPARATOR) if (d) {
              var _t4 = c[d] || [];

              u[_e15] = _t4.concat((u[_e15] || []).slice(_t4.length - 1));
            } else {
              var _r4 = c[i] || [],
                  _n5 = _r4[_r4.length - 1] || t;

              u[_e15] = _r4.concat([_n5], (u[_e15] || []).slice(_r4.length));
            }
          }

          return _objectSpread(_objectSpread({}, e), {}, {
            replacements: u
          });
        };
        var n = r(3614),
            a = r(7938),
            o = r(5362);
      },
      5575: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.insertLineSeparator = function insertLineSeparator(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.start,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.end;
          var o = e.text.slice(0, t),
              i = o.lastIndexOf(a.LINE_SEPARATOR),
              s = e.replacements[i];
          var c = [,];
          s && (c = [s]);
          var l = {
            formats: [,],
            replacements: c,
            text: a.LINE_SEPARATOR
          };
          return (0, n.insert)(e, l, t, r);
        };
        var n = r(2241),
            a = r(3614);
      },
      8791: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.insertObject = function insertObject(e, t, r, o) {
          var i = {
            formats: [,],
            replacements: [t],
            text: a.OBJECT_REPLACEMENT_CHARACTER
          };
          return (0, n.insert)(e, i, r, o);
        };
        var n = r(2241),
            a = r(3614);
      },
      2241: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.insert = function insert(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.start,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.end;
          var i = e.formats,
              s = e.replacements,
              c = e.text;
          "string" == typeof t && (t = (0, n.create)({
            text: t
          }));
          var l = r + t.text.length;
          return (0, a.normaliseFormats)({
            formats: i.slice(0, r).concat(t.formats, i.slice(o)),
            replacements: s.slice(0, r).concat(t.replacements, s.slice(o)),
            text: c.slice(0, r) + t.text + c.slice(o),
            start: l,
            end: l
          });
        };
        var n = r(9314),
            a = r(8585);
      },
      8367: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isActiveListType = function isActiveListType(e, t, r) {
          var a = e.replacements,
              o = e.start,
              i = (0, n.getLineIndex)(e, o),
              s = a[i];
          if (!s || 0 === s.length) return t === r;
          return s[s.length - 1].type === t;
        };
        var n = r(7938);
      },
      9789: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isCollapsed = function isCollapsed(e) {
          var t = e.start,
              r = e.end;
          if (void 0 === t || void 0 === r) return;
          return t === r;
        };
      },
      9408: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isEmpty = function isEmpty(e) {
          var t = e.text;
          return 0 === t.length;
        }, t.isEmptyLine = function isEmptyLine(e) {
          var t = e.text,
              r = e.start,
              a = e.end;
          if (r !== a) return !1;
          if (0 === t.length) return !0;
          if (0 === r && t.slice(0, 1) === n.LINE_SEPARATOR) return !0;
          if (r === t.length && t.slice(-1) === n.LINE_SEPARATOR) return !0;
          return t.slice(r - 1, a + 1) === "".concat(n.LINE_SEPARATOR).concat(n.LINE_SEPARATOR);
        };
        var n = r(3614);
      },
      7226: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isFormatEqual = function isFormatEqual(e, t) {
          if (e === t) return !0;
          if (!e || !t) return !1;
          if (e.type !== t.type) return !1;
          var r = e.attributes,
              n = t.attributes;
          if (r === n) return !0;
          if (!r || !n) return !1;
          var a = Object.keys(r),
              o = Object.keys(n);
          if (a.length !== o.length) return !1;
          var i = a.length;

          for (var _e16 = 0; _e16 < i; _e16++) {
            var _t5 = a[_e16];
            if (r[_t5] !== n[_t5]) return !1;
          }

          return !0;
        };
      },
      2476: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isListRootSelected = function isListRootSelected(e) {
          var t = e.replacements,
              r = e.start,
              a = (0, n.getLineIndex)(e, r),
              o = t[a];
          return !o || o.length < 1;
        };
        var n = r(7938);
      },
      5110: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.join = function join(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          "string" == typeof t && (t = (0, n.create)({
            text: t
          }));
          return (0, a.normaliseFormats)(e.reduce(function (e, r) {
            var n = r.formats,
                a = r.replacements,
                o = r.text;
            return {
              formats: e.formats.concat(t.formats, n),
              replacements: e.replacements.concat(t.replacements, a),
              text: e.text + t.text + o
            };
          }));
        };
        var n = r(9314),
            a = r(8585);
      },
      8585: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.normaliseFormats = function normaliseFormats(e) {
          var t = e.formats.slice();
          return t.forEach(function (e, r) {
            var a = t[r - 1];

            if (a) {
              var o = e.slice();
              o.forEach(function (e, t) {
                var r = a[t];
                (0, n.isFormatEqual)(e, r) && (o[t] = r);
              }), t[r] = o;
            }
          }), _objectSpread(_objectSpread({}, e), {}, {
            formats: t
          });
        };
        var n = r(7226);
      },
      7997: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.outdentListItems = function outdentListItems(e) {
          if (!(0, s.canOutdentListItems)(e)) return e;
          var t = e.text,
              r = e.replacements,
              c = e.start,
              l = e.end,
              u = (0, a.getLineIndex)(e, c),
              d = r.slice(0),
              p = r[(0, o.getParentLineIndex)(e, u)] || [],
              f = (0, a.getLineIndex)(e, l),
              m = (0, i.getLastChildIndex)(e, f);

          for (var _e17 = u; _e17 <= m; _e17++) {
            if (t[_e17] !== n.LINE_SEPARATOR) continue;

            var _r5 = d[_e17] || [];

            d[_e17] = p.concat(_r5.slice(p.length + 1)), 0 === d[_e17].length && delete d[_e17];
          }

          return _objectSpread(_objectSpread({}, e), {}, {
            replacements: d
          });
        };
        var n = r(3614),
            a = r(7938),
            o = r(1687),
            i = r(4768),
            s = r(6091);
      },
      7515: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.registerFormatType = function registerFormatType(e, t) {
          if ("string" != typeof (t = _objectSpread({
            name: e
          }, t)).name) return void window.console.error("Format names must be strings.");
          if (!/^[a-z][a-z0-9-]*\/[a-z][a-z0-9-]*$/.test(t.name)) return void window.console.error("Format names must contain a namespace prefix, include only lowercase alphanumeric characters or dashes, and start with a letter. Example: my-plugin/my-custom-format");
          if ((0, n.select)(a.store).getFormatType(t.name)) return void window.console.error('Format "' + t.name + '" is already registered.');
          if ("string" != typeof t.tagName || "" === t.tagName) return void window.console.error("Format tag names must be a string.");
          if (("string" != typeof t.className || "" === t.className) && null !== t.className) return void window.console.error("Format class names must be a string, or null to handle bare elements.");
          if (!/^[_a-zA-Z]+[a-zA-Z0-9-]*$/.test(t.className)) return void window.console.error("A class name must begin with a letter, followed by any number of hyphens, letters, or numbers.");

          if (null === t.className) {
            var _e18 = (0, n.select)(a.store).getFormatTypeForBareElement(t.tagName);

            if (_e18) return void window.console.error("Format \"".concat(_e18.name, "\" is already registered to handle bare tag name \"").concat(t.tagName, "\"."));
          } else {
            var _e19 = (0, n.select)(a.store).getFormatTypeForClassName(t.className);

            if (_e19) return void window.console.error("Format \"".concat(_e19.name, "\" is already registered to handle class name \"").concat(t.className, "\"."));
          }

          if (!("title" in t) || "" === t.title) return void window.console.error('The format "' + t.name + '" must have a title.');
          if ("keywords" in t && t.keywords.length > 3) return void window.console.error('The format "' + t.name + '" can have a maximum of 3 keywords.');
          if ("string" != typeof t.title) return void window.console.error("Format titles must be strings.");
          return (0, n.dispatch)(a.store).addFormatTypes(t), t;
        };
        var n = r(8467),
            a = r(3419);
      },
      7290: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.removeFormat = function removeFormat(e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.start,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : e.end;
          var i = e.formats,
              s = e.activeFormats,
              c = i.slice();

          if (r === o) {
            var _e20 = (0, n.find)(c[r], {
              type: t
            });

            if (_e20) {
              for (; (0, n.find)(c[r], _e20);) {
                filterFormats(c, r, t), r--;
              }

              for (o++; (0, n.find)(c[o], _e20);) {
                filterFormats(c, o, t), o++;
              }
            }
          } else for (var _e21 = r; _e21 < o; _e21++) {
            c[_e21] && filterFormats(c, _e21, t);
          }

          return (0, a.normaliseFormats)(_objectSpread(_objectSpread({}, e), {}, {
            formats: c,
            activeFormats: (0, n.reject)(s, {
              type: t
            })
          }));
        };
        var n = r(4793),
            a = r(8585);

        function filterFormats(e, t, r) {
          var n = e[t].filter(function (e) {
            var t = e.type;
            return t !== r;
          });
          n.length ? e[t] = n : delete e[t];
        }
      },
      346: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.removeLineSeparator = function removeLineSeparator(e) {
          var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
          var r = e.replacements,
              i = e.text,
              s = e.start,
              c = e.end,
              l = (0, a.isCollapsed)(e);
          var u,
              d = s - 1,
              p = l ? s - 1 : s,
              f = c;
          t || (d = c, p = s, f = l ? c + 1 : c);
          if (i[d] !== n.LINE_SEPARATOR) return;

          if (l && r[d] && r[d].length) {
            var _t6 = r.slice();

            _t6[d] = r[d].slice(0, -1), u = _objectSpread(_objectSpread({}, e), {}, {
              replacements: _t6
            });
          } else u = (0, o.remove)(e, p, f);

          return u;
        };
        var n = r(3614),
            a = r(9789),
            o = r(212);
      },
      212: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.remove = function remove(e, t, r) {
          return (0, n.insert)(e, (0, a.create)(), t, r);
        };
        var n = r(2241),
            a = r(9314);
      },
      4133: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.replace = function replace(e, t, r) {
          var a = e.formats,
              o = e.replacements,
              i = e.text,
              s = e.start,
              c = e.end;
          return i = i.replace(t, function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) {
              n[i - 1] = arguments[i];
            }

            var l = n[n.length - 2];
            var u,
                d,
                p = r;
            return "function" == typeof p && (p = r.apply(void 0, [e].concat(n))), "object" == typeof p ? (u = p.formats, d = p.replacements, p = p.text) : (u = Array(p.length), d = Array(p.length), a[l] && (u = u.fill(a[l]))), a = a.slice(0, l).concat(u, a.slice(l + e.length)), o = o.slice(0, l).concat(d, o.slice(l + e.length)), s && (s = c = l + p.length), p;
          }), (0, n.normaliseFormats)({
            formats: a,
            replacements: o,
            text: i,
            start: s,
            end: c
          });
        };
        var n = r(8585);
      },
      8091: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.slice = function slice(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e.start,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.end;
          var n = e.formats,
              a = e.replacements,
              o = e.text;
          if (void 0 === t || void 0 === r) return _objectSpread({}, e);
          return {
            formats: n.slice(t, r),
            replacements: a.slice(t, r),
            text: o.slice(t, r)
          };
        };
      },
      3614: function _(e, t) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ZWNBSP = t.OBJECT_REPLACEMENT_CHARACTER = t.LINE_SEPARATOR = void 0;
        t.LINE_SEPARATOR = "\u2028";
        t.OBJECT_REPLACEMENT_CHARACTER = "￼";
        t.ZWNBSP = "\uFEFF";
      },
      4944: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.split = function split(e, t) {
          var r = e.formats,
              n = e.replacements,
              a = e.text,
              o = e.start,
              i = e.end;
          if ("string" != typeof t) return splitAtSelection.apply(void 0, arguments);
          var s = 0;
          return a.split(t).map(function (e) {
            var a = s,
                c = {
              formats: r.slice(a, a + e.length),
              replacements: n.slice(a, a + e.length),
              text: e
            };
            return s += t.length + e.length, void 0 !== o && void 0 !== i && (o >= a && o < s ? c.start = o - a : o < a && i > a && (c.start = 0), i >= a && i < s ? c.end = i - a : o < s && i > s && (c.end = e.length)), c;
          });
        };
        var n = r(4133);

        function splitAtSelection(e) {
          var t = e.formats,
              r = e.replacements,
              a = e.text,
              o = e.start,
              i = e.end,
              s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o,
              c = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i;
          if (void 0 === o || void 0 === i) return;
          var l = {
            formats: t.slice(0, s),
            replacements: r.slice(0, s),
            text: a.slice(0, s)
          },
              u = {
            formats: t.slice(c),
            replacements: r.slice(c),
            text: a.slice(c),
            start: 0,
            end: 0
          };
          return [(0, n.replace)(l, /\u2028+$/, ""), (0, n.replace)(u, /^\u2028+/, "")];
        }
      },
      9445: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.addFormatTypes = function addFormatTypes(e) {
          return {
            type: "ADD_FORMAT_TYPES",
            formatTypes: (0, n.castArray)(e)
          };
        }, t.removeFormatTypes = function removeFormatTypes(e) {
          return {
            type: "REMOVE_FORMAT_TYPES",
            names: (0, n.castArray)(e)
          };
        };
        var n = r(4793);
      },
      3419: function _(e, t, r) {
        "use strict";

        var n = r(8424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.store = void 0;

        var a = r(8467),
            o = n(r(3310)),
            i = _interopRequireWildcard(r(1743)),
            s = _interopRequireWildcard(r(9445));

        function _getRequireWildcardCache(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
              r = new WeakMap();
          return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
            return e ? r : t;
          })(e);
        }

        function _interopRequireWildcard(e, t) {
          if (!t && e && e.__esModule) return e;
          if (null === e || "object" != typeof e && "function" != typeof e) return {
            default: e
          };

          var r = _getRequireWildcardCache(t);

          if (r && r.has(e)) return r.get(e);
          var n = {},
              a = Object.defineProperty && Object.getOwnPropertyDescriptor;

          for (var o in e) {
            if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
              var i = a ? Object.getOwnPropertyDescriptor(e, o) : null;
              i && (i.get || i.set) ? Object.defineProperty(n, o, i) : n[o] = e[o];
            }
          }

          return n.default = e, r && r.set(e, n), n;
        }

        var c = (0, a.createReduxStore)("core/rich-text", {
          reducer: o.default,
          selectors: i,
          actions: s
        });
        t.store = c, (0, a.register)(c);
      },
      3310: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0, t.formatTypes = formatTypes;
        var n = r(4793);

        function formatTypes() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 ? arguments[1] : void 0;

          switch (t.type) {
            case "ADD_FORMAT_TYPES":
              return _objectSpread(_objectSpread({}, e), (0, n.keyBy)(t.formatTypes, "name"));

            case "REMOVE_FORMAT_TYPES":
              return (0, n.omit)(e, t.names);
          }

          return e;
        }

        var a = (0, r(8467).combineReducers)({
          formatTypes: formatTypes
        });
        t.default = a;
      },
      1743: function _(e, t, r) {
        "use strict";

        var n = r(8424);
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFormatType = function getFormatType(e, t) {
          return e.formatTypes[t];
        }, t.getFormatTypeForBareElement = function getFormatTypeForBareElement(e, t) {
          return (0, o.find)(i(e), function (e) {
            var r = e.className,
                n = e.tagName;
            return null === r && t === n;
          });
        }, t.getFormatTypeForClassName = function getFormatTypeForClassName(e, t) {
          return (0, o.find)(i(e), function (e) {
            var r = e.className;
            return null !== r && " ".concat(t, " ").indexOf(" ".concat(r, " ")) >= 0;
          });
        }, t.getFormatTypes = void 0;
        var a = n(r(8235)),
            o = r(4793);
        var i = (0, a.default)(function (e) {
          return Object.values(e.formatTypes);
        }, function (e) {
          return [e.formatTypes];
        });
        t.getFormatTypes = i;
      },
      2502: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.apply = function apply(e) {
          var t = e.value,
              r = e.current,
              n = e.multilineTag,
              a = e.prepareEditableTree,
              o = e.__unstableDomOnly,
              i = e.placeholder;

          var _toDom = toDom({
            value: t,
            multilineTag: n,
            prepareEditableTree: a,
            placeholder: i,
            doc: r.ownerDocument
          }),
              s = _toDom.body,
              c = _toDom.selection;

          applyValue(s, r), void 0 === t.start || o || applySelection(c, r);
        }, t.applySelection = applySelection, t.applyValue = applyValue, t.toDom = toDom;
        var n = r(2882),
            a = r(5136);

        function createPathToNode(e, t, r) {
          var n = e.parentNode;
          var a = 0;

          for (; e = e.previousSibling;) {
            a++;
          }

          return r = [a].concat(_toConsumableArray(r)), n !== t && (r = createPathToNode(n, t, r)), r;
        }

        function getNodeByPath(e, t) {
          for (t = _toConsumableArray(t); e && t.length > 1;) {
            e = e.childNodes[t.shift()];
          }

          return {
            node: e,
            offset: t[0]
          };
        }

        function append(e, t) {
          "string" == typeof t && (t = e.ownerDocument.createTextNode(t));
          var _t7 = t,
              r = _t7.type,
              n = _t7.attributes;

          if (r) {
            t = e.ownerDocument.createElement(r);

            for (var _e22 in n) {
              t.setAttribute(_e22, n[_e22]);
            }
          }

          return e.appendChild(t);
        }

        function appendText(e, t) {
          e.appendData(t);
        }

        function getLastChild(e) {
          var t = e.lastChild;
          return t;
        }

        function getParent(e) {
          var t = e.parentNode;
          return t;
        }

        function isText(e) {
          return e.nodeType === e.TEXT_NODE;
        }

        function getText(e) {
          var t = e.nodeValue;
          return t;
        }

        function remove(e) {
          return e.parentNode.removeChild(e);
        }

        function toDom(e) {
          var t = e.value,
              r = e.multilineTag,
              o = e.prepareEditableTree,
              _e$isEditableTree = e.isEditableTree,
              i = _e$isEditableTree === void 0 ? !0 : _e$isEditableTree,
              s = e.placeholder,
              _e$doc = e.doc,
              c = _e$doc === void 0 ? document : _e$doc,
              l = [],
              u = [];
          o && (t = _objectSpread(_objectSpread({}, t), {}, {
            formats: o(t)
          }));
          return {
            body: (0, n.toTree)({
              value: t,
              multilineTag: r,
              createEmpty: function createEmpty() {
                return (0, a.createElement)(c, "");
              },
              append: append,
              getLastChild: getLastChild,
              getParent: getParent,
              isText: isText,
              getText: getText,
              remove: remove,
              appendText: appendText,
              onStartIndex: function onStartIndex(e, t) {
                l = createPathToNode(t, e, [t.nodeValue.length]);
              },
              onEndIndex: function onEndIndex(e, t) {
                u = createPathToNode(t, e, [t.nodeValue.length]);
              },
              isEditableTree: i,
              placeholder: s
            }),
            selection: {
              startPath: l,
              endPath: u
            }
          };
        }

        function applyValue(e, t) {
          var r,
              n = 0;

          for (; r = e.firstChild;) {
            var _a2 = t.childNodes[n];
            if (_a2) {
              if (_a2.isEqualNode(r)) e.removeChild(r);else if (_a2.nodeName !== r.nodeName || _a2.nodeType === _a2.TEXT_NODE && _a2.data !== r.data) t.replaceChild(r, _a2);else {
                var _t8 = _a2.attributes,
                    _n6 = r.attributes;

                if (_t8) {
                  var _e23 = _t8.length;

                  for (; _e23--;) {
                    var _n7 = _t8[_e23].name;
                    r.getAttribute(_n7) || _a2.removeAttribute(_n7);
                  }
                }

                if (_n6) for (var _e24 = 0; _e24 < _n6.length; _e24++) {
                  var _n6$_e = _n6[_e24],
                      _t9 = _n6$_e.name,
                      _r6 = _n6$_e.value;
                  _a2.getAttribute(_t9) !== _r6 && _a2.setAttribute(_t9, _r6);
                }
                applyValue(r, _a2), e.removeChild(r);
              }
            } else t.appendChild(r);
            n++;
          }

          for (; t.childNodes[n];) {
            t.removeChild(t.childNodes[n]);
          }
        }

        function applySelection(e, t) {
          var r = e.startPath,
              n = e.endPath;

          var _getNodeByPath = getNodeByPath(t, r),
              a = _getNodeByPath.node,
              o = _getNodeByPath.offset,
              _getNodeByPath2 = getNodeByPath(t, n),
              i = _getNodeByPath2.node,
              s = _getNodeByPath2.offset,
              c = t.ownerDocument,
              l = c.defaultView,
              u = l.getSelection(),
              d = c.createRange();

          d.setStart(a, o), d.setEnd(i, s);
          var p = c.activeElement;

          if (u.rangeCount > 0) {
            if (function isRangeEqual(e, t) {
              return e.startContainer === t.startContainer && e.startOffset === t.startOffset && e.endContainer === t.endContainer && e.endOffset === t.endOffset;
            }(d, u.getRangeAt(0))) return;
            u.removeAllRanges();
          }

          u.addRange(d), p !== c.activeElement && p instanceof l.HTMLElement && p.focus();
        }
      },
      6750: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.toHTMLString = function toHTMLString(e) {
          var t = e.value,
              r = e.multilineTag,
              n = e.preserveWhiteSpace;
          return createChildrenHTML((0, a.toTree)({
            value: t,
            multilineTag: r,
            preserveWhiteSpace: n,
            createEmpty: createEmpty,
            append: append,
            getLastChild: getLastChild,
            getParent: getParent,
            isText: isText,
            getText: getText,
            remove: remove,
            appendText: appendText
          }).children);
        };
        var n = r(510),
            a = r(2882);

        function createEmpty() {
          return {};
        }

        function getLastChild(e) {
          var t = e.children;
          return t && t[t.length - 1];
        }

        function append(e, t) {
          return "string" == typeof t && (t = {
            text: t
          }), t.parent = e, e.children = e.children || [], e.children.push(t), t;
        }

        function appendText(e, t) {
          e.text += t;
        }

        function getParent(e) {
          var t = e.parent;
          return t;
        }

        function isText(e) {
          var t = e.text;
          return "string" == typeof t;
        }

        function getText(e) {
          var t = e.text;
          return t;
        }

        function remove(e) {
          var t = e.parent.children.indexOf(e);
          return -1 !== t && e.parent.children.splice(t, 1), e;
        }

        function createElementHTML(e) {
          var t = e.type,
              r = e.attributes,
              a = e.object,
              o = e.children,
              i = "";

          for (var _e25 in r) {
            (0, n.isValidAttributeName)(_e25) && (i += " ".concat(_e25, "=\"").concat((0, n.escapeAttribute)(r[_e25]), "\""));
          }

          return a ? "<".concat(t).concat(i, ">") : "<".concat(t).concat(i, ">").concat(createChildrenHTML(o), "</").concat(t, ">");
        }

        function createChildrenHTML() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return e.map(function (e) {
            return void 0 !== e.html ? e.html : void 0 === e.text ? createElementHTML(e) : (0, n.escapeEditableHTML)(e.text);
          }).join("");
        }
      },
      2882: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.toTree = function toTree(e) {
          var t = e.value,
              r = e.multilineTag,
              a = e.preserveWhiteSpace,
              i = e.createEmpty,
              s = e.append,
              c = e.getLastChild,
              l = e.getParent,
              u = e.isText,
              d = e.getText,
              p = e.remove,
              f = e.appendText,
              m = e.onStartIndex,
              _ = e.onEndIndex,
              g = e.isEditableTree,
              v = e.placeholder;
          var y = t.formats,
              h = t.replacements,
              b = t.text,
              E = t.start,
              T = t.end,
              O = y.length + 1,
              P = i(),
              x = {
            type: r
          },
              R = (0, n.getActiveFormats)(t),
              C = R[R.length - 1];
          var A, L, S;
          r ? (s(s(P, {
            type: r
          }), ""), L = A = [x]) : s(P, "");

          var _loop2 = function _loop2(_e26) {
            var t = b.charAt(_e26),
                n = g && (!S || S === o.LINE_SEPARATOR || "\n" === S);
            var i = y[_e26];
            r && (i = t === o.LINE_SEPARATOR ? A = (h[_e26] || []).reduce(function (e, t) {
              return e.push(t, x), e;
            }, [x]) : [].concat(_toConsumableArray(A), _toConsumableArray(i || [])));
            var O = c(P);

            if (n && t === o.LINE_SEPARATOR) {
              var _e27 = O;

              for (; !u(_e27);) {
                _e27 = c(_e27);
              }

              s(l(_e27), o.ZWNBSP);
            }

            if (S === o.LINE_SEPARATOR) {
              var _t10 = O;

              for (; !u(_t10);) {
                _t10 = c(_t10);
              }

              m && E === _e26 && m(P, _t10), _ && T === _e26 && _(P, _t10);
            }

            if (i && i.forEach(function (e, r) {
              if (O && L && isEqualUntil(i, L, r) && (t !== o.LINE_SEPARATOR || i.length - 1 !== r)) return void (O = c(O));

              var n = e.type,
                  a = e.attributes,
                  f = e.unregisteredAttributes,
                  m = g && t !== o.LINE_SEPARATOR && e === C,
                  _ = l(O),
                  v = s(_, fromFormat({
                type: n,
                attributes: a,
                unregisteredAttributes: f,
                boundaryClass: m,
                isEditableTree: g
              }));

              u(O) && 0 === d(O).length && p(O), O = s(v, "");
            }), t !== o.LINE_SEPARATOR) {
              if (0 === _e26 && (m && 0 === E && m(P, O), _ && 0 === T && _(P, O)), t === o.OBJECT_REPLACEMENT_CHARACTER) g || "script" !== (null === (F = h[_e26]) || void 0 === F ? void 0 : F.type) ? O = s(l(O), fromFormat(_objectSpread(_objectSpread({}, h[_e26]), {}, {
                object: !0,
                isEditableTree: g
              }))) : (O = s(l(O), fromFormat({
                type: "script",
                isEditableTree: g
              })), s(O, {
                html: decodeURIComponent(h[_e26].attributes["data-rich-text-script"])
              })), O = s(l(O), "");else a || "\n" !== t ? u(O) ? f(O, t) : O = s(l(O), t) : (O = s(l(O), {
                type: "br",
                attributes: g ? {
                  "data-rich-text-line-break": "true"
                } : void 0,
                object: !0
              }), O = s(l(O), ""));
              m && E === _e26 + 1 && m(P, O), _ && T === _e26 + 1 && _(P, O), n && _e26 === b.length && (s(l(O), o.ZWNBSP), v && 0 === b.length && s(l(O), {
                type: "span",
                attributes: {
                  "data-rich-text-placeholder": v,
                  contenteditable: "false",
                  style: "pointer-events:none;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;"
                }
              })), L = i, S = t;
            } else L = i, S = t;
          };

          for (var _e26 = 0; _e26 < O; _e26++) {
            var F;

            _loop2(_e26);
          }

          return P;
        };
        var n = r(7733),
            a = r(6996),
            o = r(3614);

        function restoreOnAttributes(e, t) {
          if (t) return e;
          var r = {};

          for (var _t11 in e) {
            var _n8 = _t11;
            _t11.startsWith("data-disable-rich-text-") && (_n8 = _t11.slice("data-disable-rich-text-".length)), r[_n8] = e[_t11];
          }

          return r;
        }

        function fromFormat(e) {
          var t = e.type,
              r = e.attributes,
              n = e.unregisteredAttributes,
              o = e.object,
              i = e.boundaryClass,
              s = e.isEditableTree;
          var c = (0, a.getFormatType)(t);
          var l = {};
          if (i && (l["data-rich-text-format-boundary"] = "true"), !c) return r && (l = _objectSpread(_objectSpread({}, r), l)), {
            type: t,
            attributes: restoreOnAttributes(l, s),
            object: o
          };
          l = _objectSpread(_objectSpread({}, n), l);

          for (var _e28 in r) {
            var _t12 = !!c.attributes && c.attributes[_e28];

            _t12 ? l[_t12] = r[_e28] : l[_e28] = r[_e28];
          }

          return c.className && (l.class ? l.class = "".concat(c.className, " ").concat(l.class) : l.class = c.className), {
            type: c.tagName,
            object: c.object,
            attributes: restoreOnAttributes(l, s)
          };
        }

        function isEqualUntil(e, t, r) {
          do {
            if (e[r] !== t[r]) return !1;
          } while (r--);

          return !0;
        }
      },
      6983: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.toggleFormat = function toggleFormat(e, t) {
          if ((0, o.getActiveFormat)(e, t.type)) return t.title && (0, n.speak)((0, a.sprintf)((0, a.__)("%s removed."), t.title), "assertive"), (0, i.removeFormat)(e, t.type);
          t.title && (0, n.speak)((0, a.sprintf)((0, a.__)("%s applied."), t.title), "assertive");
          return (0, s.applyFormat)(e, t);
        };
        var n = r(9773),
            a = r(6756),
            o = r(710),
            i = r(7290),
            s = r(7346);
      },
      6758: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.unregisterFormatType = function unregisterFormatType(e) {
          var t = (0, n.select)(a.store).getFormatType(e);
          if (!t) return void window.console.error("Format ".concat(e, " is not registered."));
          return (0, n.dispatch)(a.store).removeFormatTypes(e), t;
        };
        var n = r(8467),
            a = r(3419);
      },
      9672: function _(e, t, r) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.updateFormats = function updateFormats(e) {
          var t = e.value,
              r = e.start,
              a = e.end,
              o = e.formats;
          var i = Math.min(r, a),
              s = Math.max(r, a),
              c = t.formats[i - 1] || [],
              l = t.formats[s] || [];
          t.activeFormats = o.map(function (e, t) {
            if (c[t]) {
              if ((0, n.isFormatEqual)(e, c[t])) return c[t];
            } else if (l[t] && (0, n.isFormatEqual)(e, l[t])) return l[t];

            return e;
          });

          for (; --a >= r;) {
            t.activeFormats.length > 0 ? t.formats[a] = t.activeFormats : delete t.formats[a];
          }

          return t;
        };
        var n = r(7226);
      },
      8235: function _(e, t, r) {
        "use strict";

        var n, a;

        function arrayOf(e) {
          return [e];
        }

        function createCache() {
          var e = {
            clear: function clear() {
              e.head = null;
            }
          };
          return e;
        }

        function isShallowEqual(e, t, r) {
          var n;
          if (e.length !== t.length) return !1;

          for (n = r; n < e.length; n++) {
            if (e[n] !== t[n]) return !1;
          }

          return !0;
        }

        function __WEBPACK_DEFAULT_EXPORT__(e, t) {
          var r, o;

          function clear() {
            r = a ? new WeakMap() : createCache();
          }

          function callSelector() {
            var r,
                n,
                a,
                i,
                s,
                c = arguments.length;

            for (i = new Array(c), a = 0; a < c; a++) {
              i[a] = arguments[a];
            }

            for (s = t.apply(null, i), (r = o(s)).isUniqueByDependants || (r.lastDependants && !isShallowEqual(s, r.lastDependants, 0) && r.clear(), r.lastDependants = s), n = r.head; n;) {
              if (isShallowEqual(n.args, i, 1)) return n !== r.head && (n.prev.next = n.next, n.next && (n.next.prev = n.prev), n.next = r.head, n.prev = null, r.head.prev = n, r.head = n), n.val;
              n = n.next;
            }

            return n = {
              val: e.apply(null, i)
            }, i[0] = null, n.args = i, r.head && (r.head.prev = n, n.next = r.head), r.head = n, n.val;
          }

          return t || (t = arrayOf), o = a ? function getWeakMapCache(e) {
            var t,
                a,
                o,
                i,
                s,
                c = r,
                l = !0;

            for (t = 0; t < e.length; t++) {
              if (a = e[t], !(s = a) || "object" != typeof s) {
                l = !1;
                break;
              }

              c.has(a) ? c = c.get(a) : (o = new WeakMap(), c.set(a, o), c = o);
            }

            return c.has(n) || ((i = createCache()).isUniqueByDependants = l, c.set(n, i)), c.get(n);
          } : function getRootCache() {
            return r;
          }, callSelector.getDependants = t, callSelector.clear = clear, clear(), callSelector;
        }

        r.r(t), r.d(t, {
          default: function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
        }), n = {}, a = "undefined" != typeof WeakMap;
      },
      9773: function _(e) {
        "use strict";

        e.exports = require("@wordpress/a11y");
      },
      3200: function _(e) {
        "use strict";

        e.exports = require("@wordpress/compose");
      },
      8467: function _(e) {
        "use strict";

        e.exports = require("@wordpress/data");
      },
      1753: function _(e) {
        "use strict";

        e.exports = require("@wordpress/element");
      },
      510: function _(e) {
        "use strict";

        e.exports = require("@wordpress/escape-html");
      },
      6756: function _(e) {
        "use strict";

        e.exports = require("@wordpress/i18n");
      },
      9880: function _(e) {
        "use strict";

        e.exports = require("@wordpress/keycodes");
      },
      4793: function _(e) {
        "use strict";

        e.exports = require("lodash");
      }
    },
        t = {};

    function __webpack_require__(r) {
      var n = t[r];
      if (void 0 !== n) return n.exports;
      var a = t[r] = {
        exports: {}
      };
      return e[r](a, a.exports, __webpack_require__), a.exports;
    }

    __webpack_require__.d = function (e, t) {
      for (var r in t) {
        __webpack_require__.o(t, r) && !__webpack_require__.o(e, r) && Object.defineProperty(e, r, {
          enumerable: !0,
          get: t[r]
        });
      }
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(8424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), Object.defineProperty(e, "__UNSTABLE_LINE_SEPARATOR", {
        enumerable: !0,
        get: function get() {
          return A.LINE_SEPARATOR;
        }
      }), Object.defineProperty(e, "__experimentalRichText", {
        enumerable: !0,
        get: function get() {
          return k.default;
        }
      }), Object.defineProperty(e, "__unstableCanIndentListItems", {
        enumerable: !0,
        get: function get() {
          return S.canIndentListItems;
        }
      }), Object.defineProperty(e, "__unstableCanOutdentListItems", {
        enumerable: !0,
        get: function get() {
          return F.canOutdentListItems;
        }
      }), Object.defineProperty(e, "__unstableChangeListType", {
        enumerable: !0,
        get: function get() {
          return M.changeListType;
        }
      }), Object.defineProperty(e, "__unstableCreateElement", {
        enumerable: !0,
        get: function get() {
          return N.createElement;
        }
      }), Object.defineProperty(e, "__unstableFormatEdit", {
        enumerable: !0,
        get: function get() {
          return D.default;
        }
      }), Object.defineProperty(e, "__unstableIndentListItems", {
        enumerable: !0,
        get: function get() {
          return w.indentListItems;
        }
      }), Object.defineProperty(e, "__unstableInsertLineSeparator", {
        enumerable: !0,
        get: function get() {
          return b.insertLineSeparator;
        }
      }), Object.defineProperty(e, "__unstableIsActiveListType", {
        enumerable: !0,
        get: function get() {
          return d.isActiveListType;
        }
      }), Object.defineProperty(e, "__unstableIsEmptyLine", {
        enumerable: !0,
        get: function get() {
          return f.isEmptyLine;
        }
      }), Object.defineProperty(e, "__unstableIsListRootSelected", {
        enumerable: !0,
        get: function get() {
          return u.isListRootSelected;
        }
      }), Object.defineProperty(e, "__unstableOutdentListItems", {
        enumerable: !0,
        get: function get() {
          return j.outdentListItems;
        }
      }), Object.defineProperty(e, "__unstableRemoveLineSeparator", {
        enumerable: !0,
        get: function get() {
          return E.removeLineSeparator;
        }
      }), Object.defineProperty(e, "__unstableToDom", {
        enumerable: !0,
        get: function get() {
          return x.toDom;
        }
      }), Object.defineProperty(e, "__unstableUseRichText", {
        enumerable: !0,
        get: function get() {
          return k.useRichText;
        }
      }), Object.defineProperty(e, "applyFormat", {
        enumerable: !0,
        get: function get() {
          return a.applyFormat;
        }
      }), Object.defineProperty(e, "concat", {
        enumerable: !0,
        get: function get() {
          return o.concat;
        }
      }), Object.defineProperty(e, "create", {
        enumerable: !0,
        get: function get() {
          return i.create;
        }
      }), Object.defineProperty(e, "getActiveFormat", {
        enumerable: !0,
        get: function get() {
          return s.getActiveFormat;
        }
      }), Object.defineProperty(e, "getActiveObject", {
        enumerable: !0,
        get: function get() {
          return c.getActiveObject;
        }
      }), Object.defineProperty(e, "getTextContent", {
        enumerable: !0,
        get: function get() {
          return l.getTextContent;
        }
      }), Object.defineProperty(e, "insert", {
        enumerable: !0,
        get: function get() {
          return h.insert;
        }
      }), Object.defineProperty(e, "insertObject", {
        enumerable: !0,
        get: function get() {
          return T.insertObject;
        }
      }), Object.defineProperty(e, "isCollapsed", {
        enumerable: !0,
        get: function get() {
          return p.isCollapsed;
        }
      }), Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function get() {
          return f.isEmpty;
        }
      }), Object.defineProperty(e, "join", {
        enumerable: !0,
        get: function get() {
          return m.join;
        }
      }), Object.defineProperty(e, "registerFormatType", {
        enumerable: !0,
        get: function get() {
          return _.registerFormatType;
        }
      }), Object.defineProperty(e, "remove", {
        enumerable: !0,
        get: function get() {
          return v.remove;
        }
      }), Object.defineProperty(e, "removeFormat", {
        enumerable: !0,
        get: function get() {
          return g.removeFormat;
        }
      }), Object.defineProperty(e, "replace", {
        enumerable: !0,
        get: function get() {
          return y.replace;
        }
      }), Object.defineProperty(e, "slice", {
        enumerable: !0,
        get: function get() {
          return O.slice;
        }
      }), Object.defineProperty(e, "split", {
        enumerable: !0,
        get: function get() {
          return P.split;
        }
      }), Object.defineProperty(e, "store", {
        enumerable: !0,
        get: function get() {
          return n.store;
        }
      }), Object.defineProperty(e, "toHTMLString", {
        enumerable: !0,
        get: function get() {
          return R.toHTMLString;
        }
      }), Object.defineProperty(e, "toggleFormat", {
        enumerable: !0,
        get: function get() {
          return C.toggleFormat;
        }
      }), Object.defineProperty(e, "unregisterFormatType", {
        enumerable: !0,
        get: function get() {
          return L.unregisterFormatType;
        }
      }), Object.defineProperty(e, "useAnchorRef", {
        enumerable: !0,
        get: function get() {
          return I.useAnchorRef;
        }
      });

      var n = __webpack_require__(3419),
          a = __webpack_require__(7346),
          o = __webpack_require__(9292),
          i = __webpack_require__(9314),
          s = __webpack_require__(710),
          c = __webpack_require__(1841),
          l = __webpack_require__(6237),
          u = __webpack_require__(2476),
          d = __webpack_require__(8367),
          p = __webpack_require__(9789),
          f = __webpack_require__(9408),
          m = __webpack_require__(5110),
          _ = __webpack_require__(7515),
          g = __webpack_require__(7290),
          v = __webpack_require__(212),
          y = __webpack_require__(4133),
          h = __webpack_require__(2241),
          b = __webpack_require__(5575),
          E = __webpack_require__(346),
          T = __webpack_require__(8791),
          O = __webpack_require__(8091),
          P = __webpack_require__(4944),
          x = __webpack_require__(2502),
          R = __webpack_require__(6750),
          C = __webpack_require__(6983),
          A = __webpack_require__(3614),
          L = __webpack_require__(6758),
          S = __webpack_require__(5362),
          F = __webpack_require__(6091),
          w = __webpack_require__(7959),
          j = __webpack_require__(7997),
          M = __webpack_require__(1848),
          N = __webpack_require__(5136),
          I = __webpack_require__(4731),
          k = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        if (null === e || "object" != typeof e && "function" != typeof e) return {
          default: e
        };

        var r = _getRequireWildcardCache(t);

        if (r && r.has(e)) return r.get(e);
        var n = {},
            a = Object.defineProperty && Object.getOwnPropertyDescriptor;

        for (var o in e) {
          if ("default" !== o && Object.prototype.hasOwnProperty.call(e, o)) {
            var i = a ? Object.getOwnPropertyDescriptor(e, o) : null;
            i && (i.get || i.set) ? Object.defineProperty(n, o, i) : n[o] = e[o];
          }
        }

        n.default = e, r && r.set(e, n);
        return n;
      }(__webpack_require__(4244)),
          D = t(__webpack_require__(6322));

      function _getRequireWildcardCache(e) {
        if ("function" != typeof WeakMap) return null;
        var t = new WeakMap(),
            r = new WeakMap();
        return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
          return e ? r : t;
        })(e);
      }
    }(), r;
  }();
});